// loading.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../loading-service.service'
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loading-animation',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="loading$ | async" class="loading-overlay">
      <div class="spinner"></div>
    </div>
  `,
  styles: [`
    .loading-overlay {
      position: fixed;
      top: 0; left: 0;
      width: 100%; height: 100%;
      display: flex; justify-content: center; align-items: center;
      background: rgba(0,0,0,0.3);
      z-index: 9999;
    }
    .spinner {
      width: 50px; height: 50px;
      border: 5px solid #ccc;
      border-top-color: #007bff;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `]
})
export class LoadingAnimationComponent {
  loading$ :Observable<boolean>;
  constructor(private loadingService: LoadingService) {
      this.loading$ = this.loadingService.loading$;
  }
}
